// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Formatter from '../../../../i18n/formatter';
import CurrencyExposant from '../CurrencyExposant';
import Avatar from '../history/Avatar';

const Wrap = styled.div`
  text-align: center;
`;

const Nickname = styled.p`
  font-weight: 800;
  text-align: center;
  margin: 0.6em 0;
  color: ${({ theme }) => theme.grids.colors.lightgrey};
`;

const Amount = styled(CurrencyExposant)`
  display: inline-block;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.grids.colors.grey};
  color: #fff;
  padding: 0.4em;
  min-width: 6em;
`;

const Date = styled.p`
  margin: 0.4em 0 0;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  font-family: BettingPoliticaBold, sans-serif;
  white-space: normal;
`;

type Props = {
  className?: string;
  nickname: string;
  avatarPath: string;
  amount: number;
  date: string;
};

const Contributor = ({ className, nickname, avatarPath, amount, date }: Props) => {
  return (
    <Wrap className={className}>
      <Avatar image={avatarPath} />
      {nickname && <Nickname>{nickname}</Nickname>}
      {amount && <Amount amount={amount} />}
      {date && <Date>{Formatter.formatDate(date, 'dateMedium')}</Date>}
    </Wrap>
  );
};

export default Contributor;
